module.exports = __webpack_public_path__ + "static/media/bathroom_2.f47fa7c2.jpg";